import { FormattedDate, FormattedTime } from 'react-intl';

export default function FormattedDateTime({ value }) {
	return <span className="formatting-date-time">
		<FormattedDate value={Date.parse(value)} day="2-digit" month="2-digit" year="numeric" />&nbsp;
		<FormattedTime value={Date.parse(value)} hour="2-digit" minute="2-digit" />
	</span>;
}